import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon", "toggle"]
  static values = {
    showLabel: { type: String, default: "" },
    hideLabel: { type: String, default: "" }
  }

  toggle() {
    this.visible ? this.hide() : this.show()
  }

  show() {
    this.inputTarget.type = "text"
    this.render()
  }

  hide() {
    this.inputTarget.type = "password"
    this.render()
  }

  get visible() {
    return this.inputTarget.type === "text"
  }

  render() {
    this.showIconTarget.classList.toggle("hidden", this.visible)
    this.hideIconTarget.classList.toggle("hidden", !this.visible)

    const label = this.visible ? this.hideLabelValue : this.showLabelValue
    this.toggleTarget.setAttribute("aria-label", label)
    this.toggleTarget.setAttribute("title", label)
    this.toggleTarget.setAttribute("aria-pressed", this.visible)
  }
}
